<template lang="pug">
	.matrixHeader-cell(
		@click="toggle",
		:class="{filter: filter && !authorized, active}",
		:data-category="!!data.columnGroup")
		span.matrixHeader-cell-category(
			v-if="!!data.columnGroup",
			:class="groupClass")
			span(:data-category="data.columnGroup")
		span.matrixHeader-cell-content(v-html="data._display")
		template(v-if="filter && !authorized")
			i.matrixHeader-cell-icon
				span
				span
				span
			matrix-filters(:data="data._filters", :id="data._id", :active="active")
			matrix-selections(:id="data._id")
</template>

<script>
import { mapGetters } from "vuex";
import { Header as Bus } from "@/matrix/events";
import Filters from "./filters/Filters";
import Selections from "./filters/Selections";
export default {
  name: "MatrixHeaderCell",
  props: ["data", "index"],
  components: {
    matrixFilters: Filters,
    matrixSelections: Selections
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    ...mapGetters(["computed", "authorized"]),
    filter() {
      return !!this.data.filterable;
    },
    groupClass() {
      let groupClass = new Set();
      let group = this.data.columnGroup;
      let headers = this.computed.headers;
      let index;
      let total = this.computed.headers.reduce((_total, header) => {
        if (header.columnGroup == group) _total++;
        if (header === this.data) index = _total;
        return _total;
      }, -1);

      if (
        !headers[this.index - 1] ||
        group !== headers[this.index - 1].columnGroup
      )
        groupClass.add("first");
      if (
        !headers[this.index + 1] ||
        group !== headers[this.index + 1].columnGroup
      )
        groupClass.add("last");
      if (index === Math.floor(total / 2)) {
        groupClass.add("text");
        if (total / 2 !== Math.floor(total / 2)) groupClass.add("text--push");
      }

      return [...groupClass].join(" ");
    }
  },
  methods: {
    toggle(e) {
      if (this.filter && !this.authorized) {
        e.stopPropagation();
        this.active = !this.active;
        Bus.$emit("TOGGLED", this.$el);
      }
    }
  },
  created() {
    if (this.filter && !this.authorized) {
      Bus.$on("TOGGLED", el => {
        if (this.$el != el) this.active = false;
      });
    }
  }
};
</script>

<style lang="scss">
//shadow for mobile in filter scroller
@media (max-width: 1099px) {
  .matrixHeader-cell {
    &:nth-child(odd) {
      .matrixFilters {
        background: linear-gradient(rgba($white, 0), $white 70%) 0 100%,
          radial-gradient(
              farthest-side at 50% 100%,
              rgba($black, 0.2),
              rgba($black, 0)
            )
            0 100%;
        background-repeat: no-repeat;
        background-color: $white;
        background-size: 100% 40px, 100% 14px;
        background-attachment: local, scroll;
      }
    }
    &:nth-child(even) {
      .matrixFilters {
        background: linear-gradient(rgba($mist, 0), $mist 70%) 0 100%,
          radial-gradient(
              farthest-side at 50% 100%,
              rgba($black, 0.2),
              rgba($black, 0)
            )
            0 100%;
        background-repeat: no-repeat;
        background-color: $mist;
        background-size: 100% 40px, 100% 14px;
        background-attachment: local, scroll;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.matrixHeader-cell {
  position: relative;
  display: none;
  padding: 0.5rem 0.75rem;
  color: $black;
  flex-wrap: wrap;
  &:nth-child(even) {
    background: $mist;
  }
  @media (min-width: 1100px) {
    padding: 0.5rem 0;
    border-bottom: 1px dashed $azure;
    display: flex;
    flex-wrap: nowrap;
    color: $midnight;
    &:nth-child(even) {
      background: none;
    }
  }
}

.matrixHeader-cell.filter {
  display: flex;
  cursor: pointer;
  .matrixHeader-cell-content {
    flex: 0 0 calc(100% - 1.4rem - 20px);
    max-width: calc(100% - 1.4rem - 20px);
    margin-right: 0;
    @media (min-width: 1100px) {
      flex: 0 0 auto;
    }
  }
  &.active {
    z-index: 2;
    @media (max-width: 1099px) {
      padding-bottom: 0;
    }
  }
  @media (min-width: 1100px) {
    transition: 0.25s ease;
    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      height: 5px;
      right: 0;
      left: 0;
      background: $azure;
      z-index: -1;
      opacity: 0;
      transition: 0.25s ease;
    }
    &.active,
    &:hover {
      color: $azure;
      &::after {
        opacity: 1;
      }
      .matrixHeader-cell-icon span::before {
        background: $white;
      }
    }
  }
}

.matrixHeader-cell-category {
  position: absolute;
  display: none;
  height: 1px;
  left: 0;
  width: calc(100% + 12px);
  right: -12px;
  bottom: 100%;
  margin-bottom: 8px;
  background: $nevada;
  transition: opacity 0.25s ease;
  @media (min-width: 1099px) {
    display: block;
  }
  &::before,
  &::after {
    position: absolute;
    top: -3px;
    left: 0;
    min-height: 7px;
    min-width: 7px;
    border-left: 1px solid $nevada;
    border-bottom: 1px solid $nevada;
    transform: rotate(45deg);
  }
  &.first {
    &::before {
      content: "";
    }
  }
  &.text {
    z-index: 1;
    span::after {
      content: attr(data-category);
      font-size: 13px;
      position: absolute;
      bottom: 100%;
      left: 45%;
			line-height: 1;
      background: $white;
      padding: 0 8px;
			text-align: center;
      transform: translateY(35%) translateX(-50%);
    }
    &.text--push span::after {
      left: 100%;
    }
  }
  &.last {
    right: 0;
    width: 100%;
    &::after {
      left: auto;
      right: 0;
      content: "";
      transform: rotate(-135deg);
    }
  }
}

.matrixHeader-cell-content {
  font-size: 0.875rem;
  font-weight: 700;
  flex: 0 0 100%;
  margin-right: auto;
  align-self: flex-end;
  min-height: 24px;
  //overflow: hidden;
  //text-overflow: ellipsis;
}

.matrixHeader-cell-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 1rem;
  flex: 0 0 18px;
  max-width: 18px;
  margin-left: 10px;
  align-self: flex-end;
  justify-content: center;
  height: 24px;
  color: currentColor;
  @media (min-width: 1100px) {
    margin-left: auto;
  }
  span {
    position: relative;
    display: block;
    height: 2px;
    background: currentColor;
    margin: 2px 0;
    &::before {
      position: absolute;
      top: 50%;
      left: 10%;
      width: 6px;
      height: 6px;
      content: "";
      transition: left 0.25s ease, right 0.25s ease;
      transform: translateX(0) translateY(-50%);
      border: 1px solid currentColor;
      border-radius: 50%;
      background: $midnight;
      transition: 0.25s ease;
    }
    &:nth-child(2)::before {
      right: 20%;
      left: auto;
      transform: translateX(50%) translateY(-50%);
      background: $empire;
    }
    &:nth-child(3)::before {
      transform: translateX(-50%) translateY(-50%);
      left: 35%;
      background: $azure;
    }
  }
}
</style>